import * as Bowser from 'bowser';

export const browser = window?.navigator?.userAgent
  ? Bowser.getParser(window.navigator.userAgent)
  : undefined;

export function isMobileBrowser() {
  return browser?.getPlatformType() === 'mobile';
}

export function isSafariLowerThan15() {
  return browser?.satisfies({ safari: '<15.0' });
}

export function isBrowserInFullScreen() {
  const document: any = window.document;
  return (
    (document.fullscreenElement &&
      document.fullscreenElement !== null) ||
    (document.webkitFullscreenElement &&
      document.webkitFullscreenElement !== null) ||
    (document.mozFullScreenElement &&
      document.mozFullScreenElement !== null) ||
    (document.msFullscreenElement &&
      document.msFullscreenElement !== null)
  );
}

export function requestBrowserFullScreen(elem: any) {
  if (elem.requestFullscreen) {
    elem.requestFullscreen();
  } else if (elem.mozRequestFullScreen) {
    elem.mozRequestFullScreen();
  } else if (elem.webkitRequestFullScreen) {
    elem.webkitRequestFullScreen();
  } else if (elem.msRequestFullscreen) {
    elem.msRequestFullscreen();
  } else {
    console.warn(
      'Did not find a requestFullScreen method on this element',
      elem,
    );
  }
}

export function exitBrowserFullScreen() {
  const document: any = window.document;
  if (document.exitFullscreen) {
    document.exitFullscreen();
  } else if (document.webkitExitFullscreen) {
    document.webkitExitFullscreen();
  } else if (document.mozCancelFullScreen) {
    document.mozCancelFullScreen();
  } else if (document.msExitFullscreen) {
    document.msExitFullscreen();
  }
}

// Includes an empty string because fullscreenchange without prefix is
// also a valid event we need to listen for
const prefixes = ['', 'moz', 'webkit', 'ms'];

export function addBrowserFullScreenListener(
  listener: (e: any) => void,
  options?: any,
) {
  prefixes.forEach((prefix) => {
    document.addEventListener(
      prefix + 'fullscreenchange',
      listener,
      options,
    );
  });
}
